import { Box, DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { PageHeaderWrapper, Text, Title } from "@src/appV2/redesign/system/ui-components";

import { PAGE_HEADER_SPACER_MIN_HEIGHT } from "./constants";

interface BadgeVerificationTimedOutContentProps {
  title: string;
  photoPreviewUrl: string;
  isSubmitting: boolean;
  onRetakePhoto: () => void;
  onSubmitAndClockIn: () => void;
}

export function BadgeVerificationTimedOutContent(props: BadgeVerificationTimedOutContentProps) {
  const { title, photoPreviewUrl, isSubmitting, onRetakePhoto, onSubmitAndClockIn } = props;

  return (
    <>
      <PageHeaderWrapper variant="tertiary">
        <Stack sx={{ minHeight: PAGE_HEADER_SPACER_MIN_HEIGHT }} />
      </PageHeaderWrapper>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "auto",
        }}
      >
        <Stack alignItems="center" textAlign="center" spacing={8}>
          <Title variant="h3" component="h1">
            {title}
          </Title>

          <Box
            sx={(theme) => ({
              width: "100%",
              maxWidth: 300,
              aspectRatio: "3/4",
              borderRadius: theme.shape.borderRadius,
              overflow: "hidden",
              backgroundColor: theme.palette.grey[200],
            })}
          >
            <Box
              component="img"
              src={photoPreviewUrl}
              alt="Badge photo"
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>

          <Text variant="body2" color={(theme) => theme.palette.text.secondary}>
            To verify successfully, make sure your badge is clearly shown in the photo and attached
            to your attire.
          </Text>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <LoadingButton
          fullWidth
          variant="contained"
          size="large"
          isLoading={isSubmitting}
          onClick={onSubmitAndClockIn}
        >
          Submit and clock in
        </LoadingButton>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          disabled={isSubmitting}
          onClick={onRetakePhoto}
        >
          Retake photo
        </Button>
      </DialogFooter>
    </>
  );
}
